module.exports = __webpack_public_path__ + "static/media/Closed.1c2f87e5.svg";